import BulletedList from '../src/BulletedList/index';
export default BulletedList;
